import React from 'react';
import { Shield, Users, Award, Heart } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="book-section bg-book-cream">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
            Your Trusted Gaming Companion
          </h2>
          <p className="text-xl text-book-brown-dark max-w-3xl mx-auto">
            At Brit Ember, we're more than just a review site – we're your gateway to the world's most prestigious gaming experiences,
            carefully curated for the discerning UK player.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-book-brown mb-6">
              Why Brit Ember Stands Apart
            </h3>
            <p className="text-lg text-book-brown-dark mb-6 leading-relaxed">
              In a world of fleeting trends and questionable operators, Brit Ember represents the gold standard in gaming guidance.
              We don't just list casinos – we curate experiences, verify reputations, and champion the platforms that truly deserve your trust and your wagers.
            </p>
            <p className="text-lg text-book-brown-dark mb-6 leading-relaxed">
              Our expert team brings decades of combined experience in the gaming industry, from professional betting strategies to casino operations.
              We understand what makes a platform exceptional, and we're committed to connecting you with only the finest establishments.
            </p>
            <div className="bg-book-beige rounded-lg p-6 shadow-book-inset">
              <p className="text-book-brown italic text-center">
                "Excellence isn't an accident. It's the result of unwavering commitment to quality,
                integrity, and the pursuit of extraordinary gaming experiences."
              </p>
            </div>
          </div>

          <div className="relative">
            {/* Placeholder for about image */}
            <div className="bg-gradient-to-br from-book-brown to-book-brown-light rounded-xl shadow-book h-96 flex items-center justify-center">
              <div className="text-center text-book-cream">
                <Shield className="h-16 w-16 mx-auto mb-4 opacity-80" />
                <img
                  src="/images/amanda-jones-fDtePwt9DdA-unsplash.webp"
                  alt="Brit Ember Team"
                  className="w-full h-64 object-cover rounded-lg"
                  loading="lazy"
                />
                <p className="text-sm opacity-75">Trust, Expertise, Excellence</p>
              </div>
            </div>

            {/* Floating elements */}
            <div className="absolute -top-4 -right-4 bg-book-gold rounded-full p-3 shadow-book">
              <Award className="h-6 w-6 text-book-brown" />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-book-beige rounded-full p-3 shadow-book">
              <Heart className="h-6 w-6 text-book-brown" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="book-card text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-book-brown rounded-full flex items-center justify-center">
                <Shield className="h-8 w-8 text-book-cream" />
              </div>
            </div>
            <h4 className="text-xl font-bold text-book-brown mb-3">Uncompromising Integrity</h4>
            <p className="text-book-brown-dark">
              Every recommendation is backed by rigorous verification, ensuring only licensed,
              reputable operators make our curated list.
            </p>
          </div>

          <div className="book-card text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-book-brown rounded-full flex items-center justify-center">
                <Users className="h-8 w-8 text-book-cream" />
              </div>
            </div>
            <h4 className="text-xl font-bold text-book-brown mb-3">Player-First Approach</h4>
            <p className="text-book-brown-dark">
              Your satisfaction and security are paramount. We advocate for fair play,
              responsible gaming, and exceptional user experiences.
            </p>
          </div>

          <div className="book-card text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-book-brown rounded-full flex items-center justify-center">
                <Award className="h-8 w-8 text-book-cream" />
              </div>
            </div>
            <h4 className="text-xl font-bold text-book-brown mb-3">Expertise You Can Trust</h4>
            <p className="text-book-brown-dark">
              Our recommendations aren't generic – they're informed by deep industry knowledge
              and a commitment to your gaming success.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-book-brown to-book-brown-light rounded-xl p-8 text-book-cream">
            <h3 className="text-book-cream text-2xl font-bold mb-4">Join the Brit Ember Community</h3>
            <p className="text-lg mb-6 opacity-90">
              Experience the difference that comes from choosing quality over quantity,
              integrity over hype, and excellence over mediocrity.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <a href="#offers" className="bg-book-gold text-book-brown px-8 py-3 rounded-lg hover:bg-book-beige transition-colors duration-200 font-semibold">
                Discover Premium Offers
              </a>
              <a href="#contact" className="bg-transparent border-2 border-book-cream text-book-cream px-8 py-3 rounded-lg hover:bg-book-cream hover:text-book-brown transition-colors duration-200 font-semibold">
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
